import { render, staticRenderFns } from "./ClientAgencyChart.vue?vue&type=template&id=55aed6f6&"
import script from "./ClientAgencyChart.vue?vue&type=script&lang=js&"
export * from "./ClientAgencyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports